import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const TopicUser = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 28 28">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.9135 7.77458C17.9135 9.93594 16.1614 11.6881 14 11.6881C11.8387 11.6881 10.0865 9.93594 10.0865 7.77458C10.0865 5.61321 11.8387 3.86108 14 3.86108C16.1614 3.86108 17.9135 5.61321 17.9135 7.77458ZM5.97256 18.9506C7.59236 16.7909 10.1345 15.5198 12.8341 15.5198H15.1659C17.8656 15.5198 20.4077 16.7909 22.0275 18.9506C23.386 20.7619 22.0935 23.3468 19.8294 23.3468H8.17066C5.90649 23.3468 4.61406 20.7619 5.97256 18.9506Z" stroke="#2E434D" strokeWidth="1.5"/>
      </svg>
  </SvgIcon>
  );
}

export default TopicUser;